<template>
  <Layout>
    <div class="shadow mb-16">
      <div
        class="section-header p-4 bg-grey-lighter
        flex flex-col md:flex-row justify-between border border-solid border-grey-light"
      >
        <div class="w-full md:w-2/3 flex flex-col md:flex-row items-start md:items-center mr-2">
          <h2 class="w-full md:w-auto mb-4 md:mb-0 mr-2">Menu Items</h2>
          <div class="tab-btn-container overflow-x-scroll w-full md:w-2/3">
            <div :class="['tab-btn mr-2', { active: activeBtn === 'items' }]" @click="toggleTab('items')">
              Food Items
            </div>
            <div :class="['tab-btn mr-2', { active: activeBtn === 'categories' }]" @click="toggleTab('categories')">
              Categories
            </div>
            <div :class="['tab-btn mr-2', { active: activeBtn === 'addons' }]" @click="toggleTab('addons')">
              Add-Ons
            </div>
            <div :class="['tab-btn', { active: activeBtn === 'approval' }]" @click="toggleTab('approval')">
              Approval
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/3 flex justify-end">
          <pt-form-input
            v-if="activeBtn !== 'approval'"
            id="search-input"
            v-model="searchModel"
            type="text"
            icon-class="fa-search"
            icon-position="left"
            placeholder="Search..."
            class="mt-4 md:mt-0 mr-2"
          />
          <pt-select
            v-else
            v-model="filterType"
            :options="filterTypes"
            :allow-empty="false"
            track-by="id"
            label-key="label"
            class="w-2/3 mt-4 md:mt-0"
          />
          <pt-button
            v-if="activeBtn === 'items' || activeBtn === 'categories'"
            variant="primary-outline"
            size="md"
            class="w-1/2 mt-4 md:mt-0"
            @action="activeBtn === 'items' ? showAddEditItemModal() : showAddEditCategoryModal()"
          >
            Add {{ activeBtn === 'items' ? 'Item' : 'Category' }}
          </pt-button>
          <add-edit-item-modal
            ref="addEditItemModal"
            :item-id="null"
            :categories="categories"
            :menu-hours="menuHours"
            :is-edit="false"
          />
          <add-edit-category-modal ref="addEditCategoryModal" :category="null" :is-edit="false" />
        </div>
      </div>
      <div v-if="activeBtn === 'items'">
        <Items :search="searchModel" :categories="categories" :menu-hours="menuHours" />
      </div>
      <div v-if="activeBtn === 'categories'">
        <Categories :search="searchModel" />
      </div>
      <div v-if="activeBtn === 'addons'">
        <Addons :search="searchModel" />
      </div>
      <div v-if="activeBtn === 'approval'">
        <Approval :filter-type="filterType" />
      </div>
    </div>
  </Layout>
</template>

<script>
import apiRequest from '@src/utils/apiRequest';
import Layout from '@layouts/main';

import { PtTab, PtTabItem } from '@pathao/ui-components/esm/Tabs';
import { PtButton } from '@pathao/ui-components';
import { PtSelect } from '@pathao/ui-components/esm/Select';
import Items from '@components/menu/Items';
import Addons from '@components/menu/Addons';
import Categories from '@components/menu/Categories';
import Approval from './Approval';
import { RESTO_MENU_HOURS_SUGGESTIONS, RESTO_CATEGORIES_SUGGESTIONS } from '@src/config/apiEndpoints';
import { MENU_APPROVAL_FILTERS } from '@src/constants';
import AddEditItemModal from '@components/modals/addEditItem.vue';
import AddEditCategoryModal from '@components/modals/addEditCategory.vue';
// import { mapGetters } from 'vuex';

export default {
  name: 'Menus',
  page: {
    title: 'Menus',
  },
  components: {
    Layout,
    PtTab,
    PtTabItem,
    PtButton,
    PtSelect,
    Items,
    Categories,
    Addons,
    Approval,
    AddEditItemModal,
    AddEditCategoryModal,
  },
  data() {
    return {
      searchModel: '',
      filterType: MENU_APPROVAL_FILTERS[0],
      filterTypes: MENU_APPROVAL_FILTERS,
      processing: false,
      activeBtn: 'items',
      categories: [],
      menuHours: [],
    };
  },
  watch: {
    searchModel(newValue) {
      if (newValue) {
        let push = {
          keyword: newValue,
        };
        this.$sendEvent('RS_SearchItems', push);
      }
    },
  },
  created() {
    this.getCategoriesSuggestions();
    this.getMenuHours();
    this.$sendEvent('RS_Menus');
  },
  methods: {
    showAddEditItemModal() {
      this.$refs.addEditItemModal.show();
    },
    showAddEditCategoryModal() {
      this.$refs.addEditCategoryModal.show();
    },
    toggleTab(tabName) {
      this.searchModel = '';
      this.activeBtn = tabName;
      this.$sendEvent('RS_' + tabName);
    },
    getCategoriesSuggestions() {
      let payload = {
        url: RESTO_CATEGORIES_SUGGESTIONS,
        method: 'GET',
      };
      this.fetching = true;
      apiRequest(payload)
        .then(response => {
          this.categories = response.data.data;
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
    getMenuHours() {
      let payload = {
        url: RESTO_MENU_HOURS_SUGGESTIONS,
        method: 'GET',
      };
      this.fetching = true;
      apiRequest(payload)
        .then(response => {
          this.menuHours = response.data.data;
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
